import Swiper from 'swiper';
import {Pagination, Autoplay, A11y, EffectFade} from 'swiper/modules';
import {SwiperOptions} from "swiper/types";

const sliderSettingsDefault: SwiperOptions = {
  modules: [Pagination, Autoplay, A11y, EffectFade],
  pagination: {
    el: '.fullscreen-swiper-pagination',
    clickable: true,
    type: 'bullets',
  },
  autoplay: {
    delay: 3000,
  },
  effect: 'fade',
  speed: 1000,
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  slidesPerView: 1,

  on: {
    beforeLoopFix: () => {
      const y = window.scrollY;
      requestAnimationFrame(() => window.scrollTo({ top: y, behavior: 'instant' }));
    }
  }
}

function shuffleSlides(wrapper: HTMLElement) {
  const slides = Array.from(wrapper.children)

  for (let i = slides.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    let temp = slides[i] as HTMLElement
    slides[i] = slides[j] as HTMLElement
    slides[j] = temp
  }

  slides.forEach(slide => wrapper.appendChild(slide))
}

document.querySelectorAll('.fullscreen-slider').forEach((swiper: Element) => {
  const swiperElement = swiper as HTMLElement



  if (swiperElement.dataset['randomize'] === "true") {
    shuffleSlides(swiperElement.querySelector('.swiper-wrapper')!)
  }

  let heroSlider = new Swiper(swiperElement, sliderSettingsDefault)
  heroSlider.init()
})
